"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _divider = _interopRequireDefault(require("@amzn/meridian/divider"));
var _MultipleChoiceQuestion = _interopRequireDefault(require("./MultipleChoiceQuestion"));
var _TextQuestion = _interopRequireDefault(require("./TextQuestion"));
var _QuestionTypes = _interopRequireDefault(require("../enums/QuestionTypes"));
var _StarRating = _interopRequireDefault(require("./StarRating"));
var _FeedbackConstants = require("../constants/FeedbackConstants");
var RequiredQuestionTypeComponent = function RequiredQuestionTypeComponent(_ref) {
  var _ref$question = _ref.question,
    questionText = _ref$question.questionText,
    questionId = _ref$question.questionId,
    isMandatory = _ref$question.isMandatory,
    questionType = _ref$question.questionType,
    prePopulatedValue = _ref.prePopulatedValue;
  var requiredComponent = null;
  switch (Object.keys(questionType)[0]) {
    case _QuestionTypes["default"].MULTIPLE_CHOICE_QUESTION:
      requiredComponent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MultipleChoiceQuestion["default"], {
        question: questionText,
        id: questionId,
        isMandatory: isMandatory,
        functionalities: questionType.multipleChoiceQuestionType.options
      }), /*#__PURE__*/_react["default"].createElement(_divider["default"], {
        size: "small"
      }));
      break;
    case _QuestionTypes["default"].RATING_QUESTION:
      requiredComponent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_StarRating["default"], {
        question: questionText,
        id: questionId,
        isMandatory: isMandatory,
        minRatingValue: questionType.ratingQuestionType.minRatingValue,
        ratingInterval: questionType.ratingQuestionType.ratingInterval,
        numberOfIntervals: questionType.ratingQuestionType.numberOfIntervals
      }), /*#__PURE__*/_react["default"].createElement(_divider["default"], {
        size: "small"
      }));
      break;
    case _QuestionTypes["default"].TEXT_QUESTION:
      requiredComponent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TextQuestion["default"], {
        question: questionText,
        id: questionId,
        isMandatory: isMandatory,
        limit: questionType.textQuestionType.charLimit || _FeedbackConstants.TEXT_QUESTION_RESPONSE_CHAR_LIMIT,
        prePopulatedValue: prePopulatedValue
      }), /*#__PURE__*/_react["default"].createElement(_divider["default"], {
        size: "small"
      }));
      break;
    default:
      requiredComponent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
      break;
  }
  return requiredComponent;
};
var _default = exports["default"] = RequiredQuestionTypeComponent;
//# sourceMappingURL=RequiredQuestionTypeComponent.js.map